export default [
  {
    id: 'e92b3054-2662-427a-9be1-1d48a74774e5',
    path: 'online-filling',
    name: 'online-filling',
    meta: {
      title: '在线填报',
    },
    children: [
      {
        id: '5f449210-59a3-4fb0-8ee0-fe6bd1105039',
        path: 'entity-config',
        name: 'entityConfig',
        component: () => {
          return import('../views/onlineFilling/entityConfig')
        },
        meta: {
          title: '实体对象采集配置',
        },
      },
      {
        id: 'b017a881-0a5c-4fd1-9647-06df47c0c2c9',
        path: 'entity-object-acquisition',
        name: 'entityObjectAcquisition',
        component: () => {
          return import('../views/onlineFilling/entityObjectAcquisition')
        },
        meta: {
          title: '实体对象采集',
        },
      },
      {
        id: '5b460664-c707-4f59-ac94-65d6532a38d6',
        path: 'filling',
        name: 'filling',
        component: () => {
          return import('../views/onlineFilling/excelText')
        },
        meta: {
          title: '模板设计',
          hidden: true,
        },
      },
      {
        id: '73c9c09f-dbbc-4c5d-a584-6558581cae98',
        path: 'index-monitor',
        name: 'indexMonitor',
        component: () => {
          return import('../views/onlineFilling/indexMonitor')
        },
        meta: {
          title: '数据采集监控',
        },
      },
      {
        id: '771a1b6b-cd14-430c-bcd2-ba0028c26573',
        path: 'acquisition-and-monitoring',
        name: 'acquisitionAndMonitoring',
        component: () => {
          return import('../views/onlineFilling/acquisitionMonitoring')
        },
        meta: {
          title: '数据采集监控',
        },
      },
      {
        id: 'f2e341d5-016a-46da-a328-90c871641eaf',
        path: 'time-service-monitoring',
        name: 'timeServiceMonitoring',
        component: () => {
          return import('../views/onlineFilling/TimeServiceMonitoring')
        },
        meta: {
          title: '时序数据监控',
        },
      },
      {
        id: '64eff1e6-520a-4492-bdea-460459954c1d',
        path: 'task-management',
        name: 'taskManagement',
        component: () => {
          return import('../views/onlineFilling/taskManagement')
        },
        meta: {
          title: '任务管理',
        },
      },
      {
        id: '4c90b55d-a159-4126-832e-597b85a6ed51',
        path: 'create-task',
        name: 'createTask',
        component: () => {
          return import('../views/onlineFilling/createTask')
        },
        meta: {
          title: '任务新增',
          hidden: true,
        },
      },
    ],
  },
]
